<template>
  <div>
    <v-divider v-if="!isEviction" class="mt-2 mb-5" />

    <!-- total -->
    <div class="total">
      <h4 class="subtitle-2 text-center mb-1">
        {{ $t('quote.priceTable.total') }}
      </h4>

      <!-- FCI presentation -->
      <div v-if="payWithFci">
        <h3 class="text-center">
          {{ netFCI }}
        </h3>
        <span class="d-block text-center caption">
          {{$t('quote.priceTable.usingFCI')}}
        </span>
      </div>
      <!-- /FCI presentation -->

      <!-- eviction presentation -->
      <div v-if="isEviction">
        <h3 class="text-center">
          {{ formatMoney(quoteItems.total) }}
        </h3>
        <span class="d-block text-center caption">
          {{$t('quote.priceTable.usingBalance')}}
        </span>
      </div>
      <!-- /eviction presentation -->

      <!-- normal presentation -->
      <div v-if="!payWithFci && !isEviction">
        <h3 class="text-center" :class="{ 'd-print-none': simplifiedPrinting }">
          {{ pixPaymentAmount }}
        </h3>
        <h3 class="text-center d-none d-print-block" v-if="simplifiedPrinting">
          {{ simplifiedPrintingTotal }}
        </h3>
        <p v-if="hasInstallments" class="text-center mb-0">
          <span v-if="countCardInstallments() > 1" class="caption">
            {{ $t('quote.priceTable.installmentsNumber', { installments:  countCardInstallments()}) }}
          </span>
          <span v-else class="caption">
            {{ $t('quote.priceTable.singleInstallmentNumber', { installments:  countCardInstallments()}) }}
          </span>
        </p>
      </div>
      <!-- /normal presentation -->
    </div>
    <!-- /total -->
  </div>
</template>

<script>
import { catalogMonetary } from '@/util/catalog'

export default {
  name: 'QuotePricesTotal',

  props: {
    quotes: {
      type: Object,
    },

    quoteItems: {
      type: Object,
    },

    isEviction: {
      type: Boolean,
    },

    payWithFci: {
      type: Boolean,
    },

    simplifiedPrinting: {
      type: Boolean,
    },
  },

  computed: {
    simplifiedPrintingTotal() {
      return this.formatMoney(this.pixPaymentData?.installment_value + this.quoteItems?.net_fci)
    },

    netFCI() {
      return this.formatMoney(this.quoteItems?.net_fci)
    },

    cashDiscount() {
      return this.formatMoney(this.quoteItems?.cash_discount)
    },

    pixPaymentData() {
      if (this.quoteItems?.payment_options.length <= 0) return
      return this.quoteItems?.payment_options.find(({ payment_method }) => payment_method === 'ASAAS_PIX')
    },

    pixPaymentAmount() {
      if (!this.pixPaymentData?.installment_value) return
      return this.formatMoney(this.pixPaymentData?.installment_value)
    },

    hasInstallments() {
      return this.quoteItems?.payment_options?.length >= 1
    }
  },

  methods: {
    countCardInstallments() {
      if (!this.hasInstallments) return

      return this.quoteItems?.payment_options.reduce((accumulator, item) => {
        if (item.payment_method === 'ASAAS_CREDIT_CARD') return accumulator + 1
        else return accumulator
      }, 0)
    }
  },

  data() {
    return {
      formatMoney: catalogMonetary,
      installmentNumber: 0,
    }
  },
}
</script>
